module.exports = __webpack_public_path__ + "img/advantage-item-02.c51875a3.png";